import {getPathAlias, sessionStartQPKey} from '@app/analytics/helper'
import {useIsCanonicalHost} from '@app/components/session-attributes/use-is-canonical-host'
import {useParams, usePathname, useSearchParams} from 'next/navigation'
import formatGameName from './helper'
import {GAMEPLAYER_ROUTE, USER_JOURNEY_GROUP} from '@app/constants/global'
import {interalNavigationQuery} from '.'
import {ReffererLayout} from '@app/analytics/analytics-provider/types'
import {ReffererLayoutQueryName} from '@app/analytics/analytics-provider/constants'

type Props = {
  gameCode: string
  gameName: string
  propertyCode: string
  reffererLayout?: ReffererLayout
}

export const useGameLink = ({gameCode, gameName, propertyCode, reffererLayout}: Props) => {
  const searchParams = useSearchParams()
  const pathname = usePathname()
  const params = useParams()
  const {isExtendedCanonical} = useIsCanonicalHost()
  const query = searchParams ? Object.fromEntries(searchParams.entries()) : {}
  const sessionStartPage = searchParams?.get(sessionStartQPKey) || getPathAlias(pathname || '')
  const isVastAdPublisher = ['gS0wdwooN', 'HykZUniT0vb', 'y8TYp0Ult', '7876', '7877', '7878'].includes(propertyCode)

  const gameRoutePrefix = isVastAdPublisher ? 'g' : `${params?.lang}/${GAMEPLAYER_ROUTE}`
  const route = `/${gameRoutePrefix}/${formatGameName(gameName)}/${gameCode}`

  const queryToAppend = {
    [sessionStartQPKey]: sessionStartPage,
    ...query,
    ...interalNavigationQuery,
    ...(isVastAdPublisher && {lang: params?.lang, 'user-journey-group': USER_JOURNEY_GROUP}),
    ...(reffererLayout ? {[ReffererLayoutQueryName]: reffererLayout} : {}),
  }

  return {query: queryToAppend, route, isExtendedCanonical}
}
